module.exports = __webpack_public_path__ + "static/img/exam-type03.a88d67ca.png";